import baseAPI from '@/http'

const router = 'api/pergunta/perguntaevidencia'

export const evidenceQuestionAPI = {
  update: (pergunta) => baseAPI.put(router, pergunta),
  download: (id) => baseAPI.post(`/api/arquivo/evidencia/download/${id}`, null, { responseType: 'blob' })

}
